import React from "react";
import {
  TableColumn,
  FieldType,
} from "../../../../docuclipper/DocuclipperTypes";
import { Row, Col, Form } from "react-bootstrap";
import { _FieldTypeSelector } from "./FieldTypeSelector";
type Props = {
  column: TableColumn;
  onWidthChange: (width: number) => any;
  onFieldTypeChange: (fieldType: FieldType) => any;
  onNameChange: (name: string) => any;
  placeholder: string;
};
export const ColumnConfig: React.SFC<Props> = ({
  column,
  onWidthChange,
  onFieldTypeChange,
  onNameChange,
  placeholder,
}) => {
  return (
    <Row>
      <Col xs={8}>
        <Form.Label>
          <strong>Name</strong>
        </Form.Label>
        <Form.Control
          name="columnName"
          placeholder={placeholder}
          type="text"
          value={column.name}
          onChange={(e) => onNameChange(e.target.value)}
        />
      </Col>
      {/* <td>
        <Form.Control
          type="number"
          // readOnly={true}
          value={column.columnWidthPercentage}
          onChange={(e) => onWidthChange(parseInt(e.target.value, 10))}
        />
      </td> */}

      <Col xs={4}>
        <Form.Label>
          <strong>Width</strong>
        </Form.Label>
        <Form.Control
          readOnly={true}
          value={column.columnWidthPercentage.toFixed(2)}
        />
      </Col>

      <Col xs={4} className="mt-2">
        <Form.Label>
          <strong>Field type</strong>
        </Form.Label>
        <_FieldTypeSelector
          small={true}
          selected={column.fieldType}
          onSelected={onFieldTypeChange}
        />
      </Col>
    </Row>
  );
};
